const initialState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  items: [],
  error: null,
  nbResult: 0
};
export const categoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case `RESET_CATEGORIES`: {
      return initialState;
    }
    case `FETCH_CATEGORIES_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_CATEGORIES_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case `FETCH_CATEGORIES_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error,
        items: [],
        nbResult: 0
      };
    }
    default:
      return state;
  }
};

const categoryEditorInitialState = {
  medias: [],
  id: null,
  isOpen: false,
  titleEN: "",
  titleNL: "",
  titleFR: "",
  descriptionFR: "",
  descriptionEN: "",
  descriptionNL: "",
  isPersonal: false,
  color: 1
};

export const categoryEditorReducer = (
  state = categoryEditorInitialState,
  action
) => {
  switch (action.type) {
    case "SET_CATEGORY_EDITOR": {
      return { ...state, ...action.categoryEditor };
    }
    case "RESET_CATEGORY_EDITOR": {
      return categoryEditorInitialState;
    }
    case "REMOVE_MEDIA_FROM_CATEGORY_MEDIAS": {
      return {
        ...state,
        medias: state.medias.filter(media => media.id !== action.id)
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/category.js